import {
  PretaxAccountV2Type,
  PretaxAccountStatus,
  PretaxWalletStatus,
} from 'constants/accounts';

const eligible_accounts_for_dependents = [
  PretaxAccountV2Type.FSA,
  PretaxAccountV2Type.DCFSA,
  PretaxAccountV2Type.LPFSA,
  PretaxAccountV2Type.HSA,
] as Array<string>;

const isEligibleAccountPresent = (account_name = '') =>
  eligible_accounts_for_dependents.includes(account_name.toLowerCase());

export const getShowDependentForV2 = (
  pretax_accounts: Array<{
    status?: string;
    wallet_type_id: string;
  }>
) => {
  const found =
    pretax_accounts.length &&
    pretax_accounts.find((account) => {
      const isActiveOrTempInactive =
        account?.status === PretaxWalletStatus.ACTIVE ||
        account?.status === PretaxWalletStatus.TEMPORARILY_INACTIVE;

      return (
        isActiveOrTempInactive &&
        isEligibleAccountPresent(account?.wallet_type_id)
      );
    });

  return !!found;
};

export const getShowDependentForV1 = (
  pretax_accounts: Array<{
    account_status_code: string;
    account_type_class_code: string;
  }>
) => {
  const found =
    pretax_accounts.length &&
    pretax_accounts.find(
      (account) =>
        (account?.account_status_code === PretaxAccountStatus.ACTIVE ||
          account?.account_status_code === PretaxAccountStatus.NEW) &&
        isEligibleAccountPresent(account?.account_type_class_code)
    );

  return !!found;
};

export const getCompleteDependentAddress = (address: {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
}) => {
  const {
    line1 = '',
    line2,
    city = '',
    state = '',
    zip = '',
    country = '',
  } = address;
  return [line2, city, state, zip, country].reduce((acc, current) => {
    if (current) {
      return `${acc ? `${acc},` : ''} ${current}`;
    }
    return acc;
  }, line1);
};
